import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { isLogged } from '../../selectors';
import { loginPathPrefix } from './routes';

const PrivateRoute: React.FC<RouteProps> = ({ children, component, ...routeProps }) => {
    const logged = useSelector(isLogged);

    if (!logged) {
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        return (
            <Route {...routeProps}>
                <Redirect to={`${loginPathPrefix}?returnUrl=${returnUrl}`}/>
            </Route>
        );
    }

    return (
        <Route {...routeProps} component={component}>
            {children}
        </Route>
    );
};

export default PrivateRoute;
